const SemanticDividerSchema = {
  title: 'Divider (Wildcard)',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'color',
        'thickness',
        'narrow',
      ],
    },
  ],

  properties: {

    color: {
      title: 'Color',
      type: 'string',
      choices: [
        ['#d4d4d5', 'Default'],
        ['#be1e2d', 'Red'],
        ['#163d4c', 'Teal'],
        ['#2c3437', 'Blue-Grey'],
      ],
      default: '#d4d4d5',
    },

    thickness: {
      title: 'Thickness',
      type: 'string',
      choices: [
        ['1px', 'Default'],
        ['5px', 'Thick'],
      ],
      default: '1px',
    },

    narrow: {
      title: 'Narrow',
      description: 'Creates a narrow divider',
      type: 'boolean',
      default: false,
    },
  },

  required: [],
};

export default SemanticDividerSchema;